import { useEffect, useState } from "react";

const MetadataDetail = ({ formHeaders, translate }) => {
  const [metadata, setMetadata] = useState([]);

  useEffect(() => {
    setMetadata(formHeaders);
  }, [formHeaders]);
  return (
    <div className="container bg-white px-5 py-4">
      <div className="row">
        {metadata
          .filter((header) =>
            header.details.find((detail) => detail.isSelected)
          )
          .map((item) => (
            <div
              className="col-12 d-flex flex-column my-4"
              key={item.metadata_set_id}
            >
              <p className="text-uppercase fs-5 fw-bold">
                {item.metadata_set_name}
              </p>
              <div className="d-flex flex-wrap align-items-center">
                {item.details
                  .filter((detail) => detail.isSelected)
                  .map((detail) => (
                    <div
                      className="text-center text-white bg-dark me-4 my-2 px-3 py-2 rounded"
                      key={detail.id}
                    >
                      <p className="mb-0">{detail.label}</p>
                    </div>
                  ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
export default MetadataDetail;
